<template>
  <div>
    <HeaderParticipant
      :participants="participants"
      :participant="participant"
      @selectParticipants="selectParticipants"
      @changeSelect="changeSelect"
    />
    <v-container>
      <div id="printMe2" style="display:none">
        <p>{{ $t("common.test") }}...</p>
      </div>
      <v-row :class="{ 'mt-4': !age18 }">
        <v-col md="12" class="tbReg">
          <v-data-table
            :headers="historyHeaders"
            :items="historyItems"
            :items-per-page="itemPerPage"
            :sort-by="['registrationDate']"
            :sort-desc="[true]"
            :class="classDT"
            @click:row="viewHistory"
            :no-data-text="$t('yourRegistration.no_data_available')"
            :footer-props="{
                'items-per-page-text': $t('yourRegistration.items_per_page_text'),
                'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
            }"
            :loading="loadingData"
            :loading-text="$t('yourRegistration.loading_text')"
            :headerProps="{
                'sort-by-text': $t('dataTable.sortByText')
            }"
          >

            <template v-slot:top>
              <v-dialog v-model="viewRow" max-width="504px">
                <v-card class="mx-auto">
                  <v-card-text class="bcard">
                      <div id="printMe" style="display:none;">
                        <div class="card" >
                          <div class="card-body" style="padding-left:10px; padding-right:10px;">
                            <v-row >
                              <v-col md="12" class="text-left">
                                  <v-row style="position:relative">
                                      <img src="@/assets/images/BackGroundImage.png" style="width:480px;display:inline;">
                                      <v-col style="float:left;text-align:left;position:absolute;top:68px;left:20px;">
                                          <p style="margin-bottom:2px;line-height:1;font-family:Roboto"><span style="font-weight:bold;width:100px">{{ $t("viewRegistration.event") }}</span>: {{ registrant.eventName }}</p>
                                          <p style="margin-bottom:2px;line-height:1;font-family:Roboto"><span style="font-weight:bold;width:100px">{{ $t("viewRegistration.promoter") }}</span>: {{ registrant.promoterName }}</p>
                                          <p style="margin-bottom:2px;line-height:1;font-family:Roboto"><span style="font-weight:bold;width:100px">{{ $t("viewRegistration.name") }}</span>: {{ registrant.regName }}</p>
                                          <p style="margin-bottom:2px;line-height:1;font-family:Roboto"><span style="font-weight:bold;width:100px">{{ $t("viewRegistration.class") }}</span>: {{ registrant.className }} </p>
                                          <p style="margin-bottom:2px;line-height:1;font-family:Roboto"><span style="font-weight:bold;width:100px">{{ $t("viewRegistration.number") }}</span>: {{ registrant.number }}</p>
                                          <p style="margin-bottom:2px;line-height:1;font-family:Roboto"><span style="font-weight:bold;width:100px">{{ $t("viewRegistration.token") }}</span>: {{ registrant.token }}</p>
                                      </v-col>
                                  </v-row>
                              </v-col>
                          </v-row>
                          </div>                         
                        </div>
                      </div>
                      <v-row style="padding-top: 20px;">
                          <v-col md="12" class="text-left" id="printMe1">
                              <v-row class="bg_row">
                                  <v-col md="3" cols="4">
                                      <p>{{ $t("viewRegistration.event") }}: </p>
                                      <p>{{ $t("viewRegistration.promoter") }}: </p>
                                      <p>{{ $t("viewRegistration.name") }}: </p>
                                      <p>{{ $t("viewRegistration.class") }}: </p>
                                      <p>{{ $t("viewRegistration.number") }}: </p>
                                      <p>{{ $t("viewRegistration.token") }}: </p>
                                  </v-col>
                                  <v-col md="9" cols="8">
                                      <p>{{ registrant.eventName }}</p>
                                      <p>{{ registrant.promoterName }}</p>
                                      <p>{{ registrant.regName }}</p>
                                      <p>{{ registrant.className }}</p>
                                      <p>{{ registrant.number }}</p>
                                      <p>{{ registrant.token }}</p>
                                  </v-col>
                              </v-row>
                          </v-col>
                      </v-row>
                      <v-row>
                        <v-col md="12" class="text-right">
                          <v-btn @click="printCard" class="mr-2">{{ $t("yourRegistration.print") }}</v-btn>
                          <v-btn @click="closeDelete">{{ $t("viewRegistration.close") }}</v-btn>
                        </v-col>
                      </v-row>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-icon v-if="item.status != 'Canceled'" small class="mr-2" @click="viewHistory(item)">fa far fa-eye</v-icon>
            </template>
            <template v-slot:item.eventDate="{ item }">
                <span>{{ item.eventDate | formatDateForHumans(false) }}</span>
            </template>
            <template v-slot:item.registrationDate="{ item }">
                <span>{{ item.registrationDate | formatDateForHumans }}</span>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import RegistrationService from '../../services/RegistrationService';
import AuthService from '@/services/AuthService';
import HeaderParticipant from '@/components/HeaderParticipant';
import { mapState } from 'vuex';
import { VRow, VCol, VDataTable, VCard, VCardText, VBtn, VDialog, VIcon, VContainer } from 'vuetify/lib';

export default {
  name: "YourRegistration",
  components:{
    VRow, VCol, VDataTable, VCard, VCardText, VBtn, VDialog, VIcon, VContainer,
    HeaderParticipant
  },
  data() {
    return {
      historyItems: [],
      itemPerPage:10,
      classDT:"elevation-1 dt",
      dynamicMenuItems: [],
      viewRow: false,
      registrant: {
        eventName: '',
        promoterName: '',
        regName: '',
        className: '',
        number: '',
        token: ''
      },
      headerColor: '',
      loadingData: true,
      bandLoadingParticipants: false,
      bandLoadingPartSelected: false,
      registrationRequestId: 0
    };
  },
  created(){
    this.headerColor = this.$store.getters.env.get('VUE_APP_BUTTON_COLOR');
  },
  mounted() {
    this.$emit("titlePage", "yourRegistration.title");
    this.$emit("dynamicMenuItems", this.dynamicMenuItems);
    this.getParticipants();
  },
  computed: {
    ...mapState({
      age18: (state) => state.session.age18,
      userStore: (state) => state.session.user,
      participants: (state) => state.session.participants,
      participant: (state) => state.session.participantsSelected
    }),
    historyHeaders() {
      let headers = null;
      if(this.$i18n.locale == 'en'){
        headers = [
          {
            text: this.$t("yourRegistration.view"),
            value: "actions",
            sortable: false,
            width: "70px"
          },
          {
            text: this.$t("yourRegistration.status"),
            value: "status",
            width: "110px"
          },
          {
            text: this.$t("yourRegistration.registrant_name"),
            value: "regName",
            width: "180px"
          },
          {
            text: this.$t("yourRegistration.class"),
            value: "className",
            width: "110px"
          },
          {
            text: this.$t("yourRegistration.number"),
            value: "number",
            width: "90px"
          },
          {
            text: this.$t("yourRegistration.prom_name"),
            align: "",
            sortable: false,
            value: "promoterName",
            width: "190px"
          },
          {
            text: this.$t("yourRegistration.event_name"),
            value: "eventName",
            width: "280px"
          },
          { 
            text: this.$t("yourRegistration.event_date"), 
            value: "eventDate", 
            width: "170px"
          },
          {
            text: this.$t("yourRegistration.registrant_date"),
            value: "registrationDate",
            width: "170px"
          },
          {
            text: this.$t("yourRegistration.payment"),
            value: "paymentEn",
            width: "100px"
          }
        ];
      }else if(this.$i18n.locale == 'fr'){
        headers = [
          {
            text: this.$t("yourRegistration.view"),
            value: "actions",
            sortable: false,
            width: "70px"
          },
          {
            text: this.$t("yourRegistration.prom_name"),
            align: "",
            sortable: false,
            value: "promoterName",
            width: "190px"
          },
          {
            text: this.$t("yourRegistration.event_name"),
            value: "eventName",
            width: "280px"
          },
          { 
            text: this.$t("yourRegistration.event_date"), 
            value: "eventDate", 
            width: "170px"
          },
          {
            text: this.$t("yourRegistration.registrant_date"),
            value: "registrationDate",
            width: "180px"
          },
          {
            text: this.$t("yourRegistration.registrant_name"),
            value: "regName",
            width: "180px"
          },
          {
            text: this.$t("yourRegistration.class"),
            value: "className",
            width: "110px"
          },
          {
            text: this.$t("yourRegistration.number"),
            value: "number",
            width: "90px"
          },
          {
            text: this.$t("yourRegistration.payment"),
            value: "paymentFr",
            width: "100px"
          }
        ];
      }else if(this.$i18n.locale == 'es'){
        headers = [
          {
            text: this.$t("yourRegistration.view"),
            value: "actions",
            sortable: false,
            width: "70px"
          },
          {
            text: this.$t("yourRegistration.prom_name"),
            align: "",
            sortable: false,
            value: "promoterName",
            width: "190px"
          },
          {
            text: this.$t("yourRegistration.event_name"),
            value: "eventName",
            width: "280px"
          },
          { 
            text: this.$t("yourRegistration.event_date"), 
            value: "eventDate", 
            width: "170px"
          },
          {
            text: this.$t("yourRegistration.registrant_date"),
            value: "registrationDate",
            width: "180px"
          },
          {
            text: this.$t("yourRegistration.registrant_name"),
            value: "regName",
            width: "180px"
          },
          {
            text: this.$t("yourRegistration.class"),
            value: "className",
            width: "110px"
          },
          {
            text: this.$t("yourRegistration.number"),
            value: "number",
            width: "90px"
          },
          {
            text: this.$t("yourRegistration.payment"),
            value: "paymentEs",
            width: "100px"
          }
        ];
      }
      return headers;
    }
  },
  watch: {
    viewRow(val) {
      val || this.closeDelete();
    },
    userStore(val) {
      if (val) {
        this.getParticipants();
      }
    },
    participant() {
      if (!this.bandLoadingPartSelected) {
        this.bandLoadingPartSelected = true;
        this.selectParticipants();
      }
    }
  },
  methods:{
    getParticipants() {
      if (this.bandLoadingParticipants) {
        return;
      }

      if (this.userStore) {
        this.bandLoadingParticipants = true;
        this.$store.dispatch('setParticipantsAction');
      } else {
        this.$store.dispatch('setUserAction');
      }
    },
    changeSelect(selectedParticipants) {
      this.$store.commit('setParticipantsSelected', selectedParticipants);
    },
    selectParticipants() {
      const selectedParticipants = Array.isArray(this.participant) ? this.participant : [];
      const usersId = Array.from(new Set(
        selectedParticipants
          .map((item) => Number(item.userId || item.id))
          .filter((userId) => userId > 0)
      ));

      if (this.userStore) {
        AuthService.setAuthParticipants(this.userStore.id, selectedParticipants);
      }

      this.loadRegistrations(usersId);
    },
    async loadRegistrations(usersId) {
      const requestId = ++this.registrationRequestId;

      if (usersId.length === 0) {
        this.historyItems = [];
        this.classDT = "elevation-1 dt";
        this.loadingData = false;
        return;
      }

      this.loadingData = true;
      try {
        const response = await RegistrationService.getRegistrationsUsers({ usersId });
        if (requestId !== this.registrationRequestId) {
          return;
        }

        const data = response.data.success && Array.isArray(response.data.message)
          ? response.data.message
          : [];
        this.historyItems = data.map((registration) => {
          const item = { ...registration };
          if (item.payment != null && item.payment > 0) {
            item.paymentEn = this.formatPrice(item.payment, 'en');
            item.paymentFr = this.formatPrice(item.payment, 'fr');
            item.paymentEs = this.formatPrice(item.payment, 'es');
          }
          const status = String(item.status || '');
          item.status = status.charAt(0).toUpperCase() + status.slice(1);
          return item;
        });
        this.classDT = this.historyItems.length > 10
          ? "dt elevation-1 addScroll"
          : "elevation-1 dt";
      } catch {
        if (requestId === this.registrationRequestId) {
          this.historyItems = [];
          this.classDT = "elevation-1 dt";
        }
      } finally {
        if (requestId === this.registrationRequestId) {
          this.loadingData = false;
        }
      }
    },
    viewHistory(value){
      if(value.status != 'Canceled') {
        this.registrant = value;
        this.viewRow = true;
      }
    },
    closeDelete() {
      this.viewRow = false;
    },
    printCard(){
      let contents = document.getElementById("printMe").innerHTML;
      document.body.color = "#FFF";
      let frame1 = document.createElement("iframe");
      frame1.name = "frame1";
      frame1.style.position = "absolute";
      frame1.style.top = "-10000000px";
      document.body.appendChild(frame1);
      
      let frameDoc = frame1.contentWindow ? frame1.contentWindow : frame1.contentDocument.document ? frame1.contentDocument.document: frame1.contentDocument;
      frameDoc.document.open();
      frameDoc.document.write(contents);
      frameDoc.document.close();
      setTimeout(function(){
        window.frames["frame1"].focus();
        window.frames["frame1"].print();
        document.body.removeChild(frame1);
      }, 500);
      return false;
    },
    formatPrice(value, lng){
      let val = (value/1).toFixed(2).replace('.', ',');
      val = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      if(lng == 'en')
        val = "$"+val;
      else if(lng == 'fr')
        val = val+"$";
      else if(lng == 'es')
        val = val+"$";
      
      return val;
    }
  }
};
</script>

<style>
  .bcard{
    padding-top: 25px;
  }
  .bcard p{
    margin-bottom: 0;
  }
  .cardTitle2{
    background: #45615f;
  }
  .v-data-table>.v-data-table__wrapper>table>thead>tr>th {
    background: #cccccc !important;
  }
  .v-data-table>.v-data-table__wrapper>table>tbody>tr>td{
    cursor: pointer;
  }
  .bg_row{
    background-image: url('~@/assets/images/BackGroundImage.png');
    background-size: contain !important;
    background-repeat: no-repeat !important;
    padding-top: 70px;
    padding-bottom: 70px;
    min-width: 480px;
  }
  #printMe1 {
    overflow-x: auto;
  }
  @media print{
    @page{
      size: auto;
      margin: 0mm;
    }
    html{
      background-color: #FFFFFF;
      margin: 0px;
    }
    body{
      margin: 10mm 15mm 10mm 15mm;
    }
  }
  th.sortable {
    white-space: nowrap !important;
  }
</style>
